import { render } from "./contactUs.vue?vue&type=template&id=72c56075&scoped=true"
import script from "./contactUs.vue?vue&type=script&lang=js"
export * from "./contactUs.vue?vue&type=script&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=72c56075&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c56075"]])

export default __exports__